<template>
  <div class="shoppingCart">
    <!-- 购物车头部 -->
    <p class="cart-header">
      {{ $t('cart.cart') }}
    </p>
    <div>
      <el-checkbox v-model="isAllCheck"></el-checkbox>
      <span style="font-size: 3.467vw;color: #000;font-weight: bold;margin-left: 1.6vw;">Select All</span>
    </div>
    <!-- 购物车主要内容区 -->
    <div class="content" v-if="getShoppingCart.length > 0">
      <div>
        <div class="list" v-for="(item, index) in getShoppingCart" :key="item.id">
          <el-checkbox :value="item.check" @change="checkChange($event, index)"></el-checkbox>
          <div style="margin-left: 1.555vw;">
            <router-link :to="{ path: '/detail', query: { spuId: item.spuId } }">
              <img style=" height: 18.4vw; width: 18.4vw;border: 1px solid #D9D9D9;border-radius: 1.333vw;"
                v-lazy="item.imageUrl" />
            </router-link>
          </div>
          <div style="margin-left: 1.867vw;flexGrow: 1;">
            <div style="display: flex;justify-content: space-between;">
              <p style="font-size: 3.2vw;font-weight: bold;color: #000;">{{ item.skuName }}</p>
              <i class="el-icon-close" style="font-size: 4.267vw;margin-left: 3px;" @click="deleteData(item.id)"></i>
            </div>
            <div style="display: flex;justify-content: space-between;margin-top: 2vw;">
              <div>
                <p style="color: #B4BAC1;font-size: 2.133vw;">Unit Price</p>
                <p style="font-size: 3.467vw;">${{ item.price }}</p>
              </div>
              <div>
                <el-input-number v-if="item.isLcl === 0" style="width: 26.667vw;" :step="item.amount" size="mini"
                  :value="item.num" @change="handleChange($event, index, item.id)" :min="0" :max="item.stockNum"
                  step-strictly></el-input-number>
                <el-input-number v-else style="width: 26.667vw;" size="mini" :value="item.num"
                  @change="handleChange($event, index, item.id)" :min="0" :max="item.stockNum"></el-input-number>
              </div>
            </div>
          </div>
        </div>
        <div class="cart-bar">
          <span style="font-size: 3.467vw;color: #000;">{{ $t('cart.total') }} <span class="cart-total-num">
              {{ getNum }}</span> {{ $t('table.pieces') }}，{{ $t('cart.chosen') }}
            <span class="cart-total-num">{{ getCheckNum }}</span> {{ $t('table.pieces') }}
          </span>
        </div>
        <div class="total-price-title">
          <p>Grand Total:</p>
          <p>$ {{ getTotalPrice }}</p>
        </div>
        <button class="btn" @click="send" :class="getCheckNum > 0 ? 'btn-primary' : 'btn-primary-disabled'">Place
          Order</button>
      </div>
    </div>
    <div v-else class="cart-empty">
      <div class="empty">
        <h2>Your cart is still empty！</h2>
        <p>Go shopping！</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      value: '',
    };
  },
  mounted() {
  },
  methods: {
    ...mapActions(["updateShoppingCart", "deleteShoppingCart", "checkAll"]),
    // 修改商品数量的时候调用该函数
    handleChange(currentValue, key, id) {
      // 当修改数量时，默认勾选
      this.updateShoppingCart({ key: key, prop: "check", val: true });
      // 向后端发起更新购物车的数据库信息请求
      this.$axios
        .post("/api/mall/cart/updateCart", {
          id: id,
          num: currentValue
        })
        .then(res => {
          switch (res.data.code) {
            case 200:
              // 更新vuex状态
              this.updateShoppingCart({
                key: key,
                prop: "num",
                val: currentValue
              });
              break;
            default:
              this.notifyError(res.data.message);
          }
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },
    send() {
      const type = this.$store.getters.getUser.umsType
      if (type !== 0 && this.getTotalPrice < 5000) {
        this.$message({
          showClose: true,
          message: 'You should place order over $5000',
          type: 'warning',
          center: true
        });
      } else {
        this.$router.push({
          path: '/placeorder',
        })
      }
    },
    deleteData(id) {
      var that = this
      this.$confirm(this.$t('cart.del'), this.$t('cart.tip'), {
        confirmButtonText: this.$t('cart.confirm'),
        cancelButtonText: this.$t('cart.think'),
        type: 'warning',
        center: true
      }).then(() => {
        that.deleteItem(id)
      }).catch(() => {
      });
    },
    formatF(value) {
      let value1 = Math.round(parseFloat(value) * 100) / 100;
      let s = value.toString().split(".");
      if (s.length == 1) {
        value1 = value.toString() + ".00";
        return value1;
      }
      if (s.length > 1) {
        if (s[1].length < 2) {
          value1 = value.toString() + "0";
        }
        return value1;
      }
    },
    checkChange(val, key) {
      // 更新vuex中购物车商品是否勾选的状态
      this.updateShoppingCart({ key: key, prop: "check", val: val });
    },
    // 向后端发起删除购物车的数据库信息请求
    deleteItem(id) {
      this.$axios
        .post("/api/mall/cart/deleteCart", {
          memberId: this.$store.getters.getUser.id,
          id: id
        })
        .then(res => {
          switch (res.data.code) {
            case 200:
              // “001” 删除成功
              // 更新vuex状态
              this.deleteShoppingCart(id);
              // 提示删除成功信息
              this.notifySucceed(this.$t('cart.deleted'));
              break;
            default:
              // 提示删除失败信息
              this.notifyError(res.data.message);
          }
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },
  },
  computed: {
    ...mapGetters([
      "getShoppingCart",
      "getCheckNum",
      "getTotalPrice",
      "getNum"
    ]),
    isAllCheck: {
      get() {
        return this.$store.getters.getIsAllCheck;
      },
      set(val) {
        this.checkAll(val);
      }
    }
  }
};
</script>
<style scoped>
.shoppingCart {
  font-size: 16px;
  border-top: 1px solid #c7c7c7;
  margin-top: -1px;
  padding: 17px 29px 80px 20px;
}

.cart-header {
  font-weight: bold;
  font-size: 20px;
  color: #333;
  margin-bottom: 17px;
}

.content {
  margin-top: 16px;
}

.list {
  border-top: 1px solid #D9D9D9;
  display: flex;
  width: 247px;
  height: 92px;
  align-items: center;
}

/* 购物车主要内容区CSS */
table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  /* 将表格内容水平居中 */
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #333;
  border-color: #959595;
}

::v-deep .el-input-number__decrease:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled),
.el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) {
  border-color: #959595;
}

::v-deep .el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled),
.el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) {
  border-color: #959595;
}

th,
td {
  padding: 8px 0;
  text-align: center;
  border-bottom: 1px solid #ccc;
}

td {
  height: 146px;
}

.cart-bar {
  margin-top: 30px;
  padding-bottom: 13px;
  border-bottom: 1px solid #D9D9D9;
}

.cart-total-num {
  font-weight: bold;
}

.total-price-title {
  font-size: 17px;
  margin-top: 7px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}

.btn {
  width: 116px;
  height: 28px;
  margin-top: 14px;
  float: right;
  border: none;
  border-radius: 5px;
  background-color: #000;
  color: #FFF;
}

.btn-primary-disabled {
  pointer-events: none;
}

.no-border td {
  border-bottom: none !important;
}

/* 购物车为空的时候显示的内容CSS */
.shoppingCart .cart-empty {
  width: 375px;
  margin: 0 auto;
}

.shoppingCart .cart-empty .empty {
  height: 300px;
  padding: 0 auto;
  margin: 65px 0 0;
  color: #b0b0b0;
  overflow: hidden;
}

.shoppingCart .cart-empty .empty h2 {
  margin: 70px 0 15px;
  font-size: 36px;
}

.shoppingCart .cart-empty .empty p {
  margin: 0 0 20px;
  font-size: 20px;
}

.kuanshi {
  color: #855d5d;
  font-size: 12px;
  margin-left: 10px;
}

/* 购物车为空的时候显示的内容CSS END */
</style>